import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import About from '../components/About';
import Team from '../components/Team';
import { CheckCircle2 } from 'lucide-react';

export default function AboutPage() {
  return (
    <>
      <Header />
      <div className="page-hero" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1494412519320-aa613dfb7738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxjYXJnbyUyMGxvZ2lzdGljc3xlbnwwfHx8fDE3ODc0OTI0NTd8MA&ixlib=rb-4.1.0&q=85)', paddingTop: '80px' }}>
        <div className="text-center max-w-3xl mx-auto px-6">
          <p className="uppercase text-xs tracking-[0.4em] mb-3 opacity-80">Who We Are</p>
          <h1 className="text-4xl md:text-6xl font-light" style={{ fontFamily: 'Playfair Display, serif' }}>About Vedyah Exim</h1>
          <div className="mx-auto w-16 h-[2px] bg-white/70 mt-5" />
        </div>
      </div>
      <About />

      <section className="py-20 bg-[color:var(--brand-soft)]/40">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-6">
          {[
            { t: 'Our Mission', d: 'To be the most trusted logistics partner, delivering value through service excellence and continuous innovation.' },
            { t: 'Our Vision', d: 'To simplify logistics by becoming a trusted single-window partner for our customers, delivering seamless end-to-end solutions through efficient coordination and dependable service.' },
            { t: 'Our Commitment', d: "At Vedyah Exim, we don't just move cargo — we simplify the journey from origin to destination" }
          ].map((c, i) => (
            <div key={i} className="bg-white p-8 rounded-md border border-[color:var(--line)]">
              <CheckCircle2 className="text-[color:var(--brand)] mb-4" />
              <h3 className="text-xl font-semibold mb-3">{c.t}</h3>
              <p className="text-[color:var(--muted)] text-sm leading-relaxed">{c.d}</p>
            </div>
          ))}
        </div>
      </section>
      <Team />
      <Footer />
    </>
  );
}
